<template>
  <div class="container">
    <div class="p-top">
      <span :class="tabIndex == 1 ? 'qb' : 'yt'" @click="chooseTab(1)">
        全部
      </span>
      <span :class="tabIndex == 2 ? 'qb' : 'yt'" @click="chooseTab(2)">
        有图
      </span>
    </div>
    <van-list
      style="width: 100%"
      :loading="loading"
      :finished="complated"
      :total="total"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-if="commentDetails && commentDetails.length > 0">
        <div v-for="(comment, index) in commentDetails" :key="index">
          <div class="p-middle">
            <div class="p-middle-one middle">
              <div>
                <div class="p-item p-item-img">
                  <img :src="require('@/assets/icon/portrait.jpg')" alt="" />
                </div>
                <div class="p-item">
                  <span style="">{{ comment.userName }}</span>
                </div>
              </div>
              <div class="p-item">
                <van-icon
                  name="star"
                  color="#ee0a24"
                  v-for="(star, index) in comment.startNum"
                  :key="index"
                ></van-icon>
              </div>
              <div class="item">
                <span>{{ comment.createTime }}</span>
              </div>
            </div>
            <div class="p-middle-two middle">
              <!-- <p
                id="p"
                ref="detailDom"
                :class="[comment.sss ? '' : 'ellipsis']"
              >
                {{ comment.content }}
              </p>
              <a href="#" @click="xxx(comment, index)">{{
                comment.sss ? "收起" : "展开"
              }}</a> -->
              <p
                id="p"
              >
                {{ comment.content }}
              </p>
            </div>
            <div class="p-middle-three middle imgbox" v-if="comment.commentImg!=''&&comment.commentImg!=null">
              <div v-for="(item, imgIndex) in comment.commentImg.split(',')" :key="imgIndex" class="img">
                <van-image
                  width="100"
                  height="100"
                  lazy-load
                  :src="item"
                  v-if="imgIndex != comment.commentImg.split(',').length-1"
                  @click="previewImg(comment.commentImg.split(','), imgIndex)"
                />
              </div>
            </div>
            <!-- <div class="p-middle-four middle" v-if="comment.writeBackList">
                        <div v-for="(back, backIndex) in comment.writeBackList" :key="backIndex">
                            <div class="p-padding" v-if="backIndex==0 || comment.message">
                                <p id="p">客服回复：{{ back.content }}</p>

                            </div>
                        </div>
                        <a href="#" @click="messageClick(comment)">{{ comment.message ? "收起" : "展开" }}</a>
                    </div> -->
          </div>
        </div>
      </div>
      <div v-if="commentDetails.length <= 0">
        <notData
          title="暂无评论"
          :img="notImg"
          content="暂时还没有相关评价哦"
          :notbutton="notbutton"
        ></notData>
      </div>
    </van-list>
    <!-- <div class="tab_ge"></div> -->
  </div>
</template>

<script>
import { getCommentCount, getProductCommentApi } from "@/api/api";
import { ImagePreview } from "vant";
import notData from "@/components/notData.vue";
export default {
  components: {
    notData,
  },
  data() {
    return {
      complated: false,
      loading: false,
      finished: false,
      total: "",
      pageNum: 1,
      notImg: require("../../../../static/images/product/not-comment.png"),
      message: false, //是否展开客服回复消息
      startNum: "",
      sss: false,
      mmm: false,
      notbutton: true,
      tabIndex: 1, // 默认全部
      commentDetails: [],
      showAll: false,
      productId: this.$route.query.productId, // 商品id
      start: 1, // 请求页数
      limit: 10, // 每次请求条数
      commentImg:[]

      // id: this.$route.query.id,
    };
  },

  methods: {
    onLoad() {
      if (!this.loading) {
        this.loading = true; //证明正在加载中 阻断 调用onLoad
        this.queryProductCommentList(this.tabIndex); //反向loading 没在加载中 可以进入
      }
    },
    messageClick(item) {
      this.$set(item, "message", !item.message);
    },
    xxx(item, index) {
      if (!item.sss) {
        document.getElementById("p").style.height = "auto";
        this.$set(item, "sss", true);
      } else {
        document.getElementById("p").style.height = "20px";
        this.$set(item, "sss", false);
      }
    },
    // 获取商品评论
    async queryProductCommentList(index) {
      const hbscToken =
        this.$cookies.get("hbscToken") ||
        sessionStorage.getItem("hbscToken") ||
        "";
      const memberId =
        this.$cookies.get("memberId") ||
        sessionStorage.getItem("memberId") ||
        "";
      // if (!hbscToken || !memberId) {
      //     this.complated = true;
      //     this.loading = false; //关闭加载
      //     return;
      // }
      var id = this.$route.query.id;
      console.log(id);
      let params = {
        productId: id,
        pageNum: this.pageNum,
        pageSize: 10,
        commentType: index == 2 ? 1 : null,
      };
      let res = await getProductCommentApi(params);

      if (res.code == "0000") {
        if (res.data.pageNum != this.pageNum) {
          //返回的当前页与传入的当前页不符合 证明存在重复加载的嫌疑
          this.pageNum = res.data.pageNum + 1;
          return false;
        }
        this.commentDetails = this.commentDetails.concat(res.data.list); //拼接查询结果
        this.total = res.data.total; //获取最大条数
        if (this.pageNum * params.pageSize > res.data.total) {
          //如果当前页和每页显示条数大于total证明查询结果不够12条 显示没有更多 否则 不显示
          this.complated = true;
        } else {
          this.complated = false;
        }
        this.pageNum = this.pageNum + 1; //当前页加一
        this.loading = false; //关闭加载
      } else {
        this.complated = true;
        this.loading = false; //关闭加载
      }
    },

    // 预览图片
    previewImg(comment, imgIndex) {
      let images = [];
      comment.forEach((item,index) => {
          if (index != comment.length-1) {
              images.push(item);
          }
      });
      ImagePreview({
        images: images,
        showIndex: true,
        loop: false, //是否循环播放
        startPosition: imgIndex,
      });
    },
    // 切换tab
    chooseTab(i) {
      this.tabIndex = i;
      this.pageNum = 1
      this.commentDetails = []
      this.queryProductCommentList(i);
    },
  },
  mounted() {
    this.queryProductCommentList(1);
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.container {
  .tab_ge {
    width: 100%;
    height: 20px;
    background-color: #f7f7f7;
  }

  .p-top {
    padding: 30px 20px;
    display: flex;

    span {
      margin-right: 30px;
      color: #fff;
      font-size: 30px;
    }

    .qb {
      text-align: center;
      display: block;
      padding: 0 26px;
      height: 52px;
      line-height: 52px;
      border-radius: 29px;
      background-color: $theme-color-main;
    }

    .yt {
      text-align: center;
      display: block;
      padding: 0 26px;
      height: 52px;
      line-height: 52px;
      color: #666666;
      background: #f5e1e2;
      border-radius: 29px;
    }
  }

  .p-middle {
    background-color: #fff;
    padding: 30px 20px;

    .middle {
      padding: 20px 0;
    }

    .p-middle-one {
      display: flex;
      align-items: center;

      .p-item-img img {
        width: 70px;
        height: 70px;
        border-radius: 70px;
      }

      .p-item {
        padding-right: 20px;

        span {
          font-size: 32px;
          color: #333333;
          display: block;
        }
      }

      .item {
        flex: 1;
        font-size: 24px;
        color: #999999;
        text-align: right;
      }

      // justify-content: ;
    }

    .p-middle-two {
      //   overflow: hidden;

      #p {
        font-size: 30px;
        height: 40px;
        color: #333;
      }

      a {
        float: right;
        color: #333;
        font-size: 22px;
      }
    }

    .p-middle-four {
      /*height: 100px;*/
      width: 710px;
      background: #f8f8f8;
      border-radius: 14px;
      overflow: hidden;

      .p-padding {
        padding-top: 20px;
        padding-left: 20px;
      }

      #p {
        font-size: 20px;
        height: 40px;
        overflow: hidden;
        color: #666;
      }

      a {
        color: #353535;
        float: right;
      }
    }
  }

  .p-bottom {
    padding: 50px 0;
    text-align: center;

    p {
      color: #9a9a9a;
    }
  }
}

.van-icon-star::before {
  width: 28px;
  height: 28px;
  color: $theme-color-main;
}

.van-uploader__preview {
  margin: 0 8px !important;
}
.imgbox{
    display: flex;
    .van-image{
        margin-right: 10px;
        border: 1px solid #999;
    }
}
</style>
